<template>
    <header class="app-header">
        <div class="container">
            <div class="logo-serve">
                <h1 class="logo animate__animated" v-animate="'animate__rotateIn'">
                    <RouterLink to="/"></RouterLink>
                </h1>
                <div class="logo-title">
                    <h4>提供Soul广告开户和投放运营</h4>
                    <h4>专业运营团队1对1服务</h4>
                </div>
            </div>
            <APPHeaderNav></APPHeaderNav>
        </div>
    </header>
</template>

<script>
import APPHeaderNav from './app-header-nav.vue'
export default {
  name: 'AppHeader',
  components: {
    APPHeaderNav
  }
}
</script>

<style scoped lang="less">
.app-header {
  height: 102px;
  color: #fff;
  font-weight: 600;
  background: url(~@/assets/images/-2477.png);
  .container {
    display: flex;
    align-items: center;
  }
  .logo-serve {
    display: flex;
    font-size: 12px;
    .logo {
      width: 41px;
      a {
        display: block;
        height: 102px;
        width: 100%;
        text-indent: -9999px;
        background: url(~@/assets/images/24990105.png) no-repeat center 30px /
          contain;
      }
    }
    .logo-title {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 22px;
    }
  }
}
</style>
